import React from "react"
import Link from "gatsby-link"
import YellowButtonMD from "../components/Buttons/YellowButtonMD"

export default ({ data }) => {
    const news = data.markdownRemark;
    
    return (
        <div>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1>
                            {news.frontmatter.title} &ndash; ({news.frontmatter.desc})
                        </h1>
                        <h5><span style={{color: 'rgba(218, 165, 32, 0.822)'}} className="glyphicon glyphicon-calendar"></span> {news.frontmatter.date}</h5>
                        <h5>Posted By: {news.frontmatter.author}</h5>
                        <hr />
                        <div dangerouslySetInnerHTML={{__html: news.html}} />
                    </div>
                    <div className="col-lg-12">
                        <YellowButtonMD path="/news">&laquo; Return to News</YellowButtonMD>
                    </div>
                </div>
            </div>
        </div>
    )
}

export const query = graphql`
    query NewPostQuery($path: String!) {
        markdownRemark(frontmatter: {path: {eq: $path}}) {
            html
            frontmatter {
                title
                date(formatString: "MMMM DD, YYYY")
                author
                desc
            }
        }
    }
`


// WEBPACK FOOTER //
// ./src/templates/new-post.js